export default class isn {
  static DataScroll(data) {
    const targets = Array.from(document.querySelectorAll(data));
    const options = {
      rootMargin: "0px 0px -25% 0px",
      threshold: [0, 0.3, 0.7, 1.0]
    };
    const observer = new IntersectionObserver(function DataScroll(
      entries,
      object
    ) {
      entries.forEach(entry => {
        const div = entry.target;
        const data_val = div.dataset.scroll;
        if (entry.isIntersecting && entry.intersectionRatio > 0) {
          div.classList.add("js-active");
          div.classList.add(data_val);
          object.unobserve(div);
        } else if (!entry.isIntersecting && entry.intersectionRatio == 0) {
          if (div.classList.contains(data_val)) {
            div.classList.remove("js-active");
            div.classList.remove(data_val);
          }
        }
      });
    },
    options);
    targets.forEach(div => {
      observer.observe(div);
    });
  }

  static DataSrc(data) {
    const targets = Array.from(document.querySelectorAll(data));
    const options = {
      rootMargin: "300px 0px 300px 0px",
      threshold: [0, 0.1, 0.3, 0.6, 0.9, 1.0]
    };
    const observer = new IntersectionObserver(function DataSrc(
      entries,
      object
    ) {
      entries.forEach(entry => {
        const img = entry.target;
        const img_path = "data-src";
        const img_path_srcset = "data-srcset";
        const img_path_poster = "data-poster";
        const src_val = img.getAttribute(img_path);
        const src_val_srcset = img.getAttribute(img_path_srcset);
        const src_val_poster = img.getAttribute(img_path_poster);
        if (src_val && entry.intersectionRatio > 0) {
          img.src = src_val;
          img.removeAttribute(img_path);
          if(src_val_srcset) {
            img.srcset = src_val_srcset;
            img.removeAttribute(img_path_srcset);
          }
          if(src_val_poster) {
            img.poster = src_val_poster;
            img.removeAttribute(img_path_poster);
          }
          img.classList.add("js-src_active");
          img.parentNode.classList.add("js-src_active_parent");
          img.parentNode.parentNode.classList.add("js-src_active_root");
        }
      });
    },
    options);
    targets.forEach(img => {
      observer.observe(img);
    });
  }

  static DataHref(data) {
    const targets = Array.from(document.querySelectorAll(data));
    const options = {
      rootMargin: "300px 0px 300px 0px",
      threshold: [0, 0.1, 0.3, 0.6, 0.9, 1.0]
    };
    const observer = new IntersectionObserver(function DataSrc(
      entries,
      object
    ) {
      entries.forEach(entry => {
        const img = entry.target;
        const img_path = "data-href";
        const src_val = img.getAttribute(img_path);
        // if (src_val && entry.intersectionRatio > 0) {
        if (src_val) {
          img.setAttribute('href', src_val);
          img.removeAttribute(img_path);
          img.classList.add("js-href_active");
          img.parentNode.classList.add("js-href_active_parent");
          img.parentNode.parentNode.classList.add("js-href_active_root");
        }
      });
    },
    options);
    targets.forEach(img => {
      observer.observe(img);
    });
  }

  static DataBack(data) {
    const targets = Array.from(document.querySelectorAll(data));
    const options = {
      rootMargin: "300px 0px 300px 0px",
      threshold: [0, 0.1, 0.3, 0.6, 0.9, 1.0]
    };
    const observer = new IntersectionObserver(function DataBack(
      entries,
      object
    ) {
      entries.forEach(entry => {
        const img = entry.target;
        const img_path = "data-back";
        const src_val = img.getAttribute(img_path);
        if (src_val && entry.intersectionRatio > 0) {
          img.src = src_val;
          img.removeAttribute(img_path);
          img.style.backgroundImage = "url( " + src_val + ")";
          object.unobserve(img);
        }
      });
    },
    options);
    targets.forEach(img => {
      observer.observe(img);
    });
  }

  static DataElementHide(data) {
    const targets = Array.from(document.querySelectorAll(data));
    const options = {
      rootMaring: "0px 0px 0px 0px",
      threshold: [0.02, 0.5, 0.08]
    };
    const observer = new IntersectionObserver(function DataElementHide(
      entries,
      object
    ) {
      entries.forEach(entry => {
        const div = entry.target;
        const data_val = div.dataset.element_hide;
        if (entry.intersectionRatio < 0.02) {
          if (!div.classList.contains(data_val)) {
            div.classList.add(data_val);
            div.classList.remove(data_val + "-del");
            document.body.classList.add(data_val + "-body");
            document.body.classList.remove(data_val + "-del-body");
          }
        } else if (entry.intersectionRatio >= 0.02) {
          //要素外
          if (div.classList.contains(data_val)) {
            div.classList.remove(data_val);
            div.classList.add(data_val + "-del");
            document.body.classList.remove(data_val + "-body");
            document.body.classList.add(data_val + "-del-body");
          }
        }
      });
    },
    options);
    targets.forEach(div => {
      observer.observe(div);
    });
  }

}
